import { useState } from "react"
import { useTranslation } from "react-i18next"
import { T } from "../theme"
import { MCard, MChip, MHeader, SectionLabel } from "../primitives"
import { ActivityRow } from "./Home"
import type { MobileAsset, MobileEvent } from "../types"

interface ActivityScreenProps {
  events: MobileEvent[]
  onOpenAsset: (asset: Pick<MobileAsset, "id" | "code">) => void
}

type Filter = "all" | "stage" | "move"

const FILTER_OPTIONS: { key: Filter; labelKey: string }[] = [
  { key: "all",   labelKey: "mobile.activity.filterAll" },
  { key: "stage", labelKey: "mobile.activity.filterStages" },
  { key: "move",  labelKey: "mobile.activity.filterMoves" },
]

export function ActivityScreen({ events, onOpenAsset }: ActivityScreenProps) {
  const { t } = useTranslation()
  const [filter, setFilter] = useState<Filter>("all")
  const filtered = events.filter((e) => {
    if (filter === "all") return true
    return e.type === filter
  })

  return (
    <div>
      <MHeader
        title={t("mobile.activity.title")}
        subtitle={t("mobile.activity.subtitle")}
      />

      <div
        style={{
          padding: "12px 16px 8px",
          background: T.surface,
          borderBottom: `1px solid ${T.borderSoft}`,
        }}
      >
        <div style={{ display: "flex", gap: 6 }}>
          {FILTER_OPTIONS.map((f) => (
            <MChip
              key={f.key}
              active={filter === f.key}
              onClick={() => setFilter(f.key)}
            >
              {t(f.labelKey)}
            </MChip>
          ))}
        </div>
      </div>

      <div style={{ padding: "16px 16px 100px" }}>
        <SectionLabel>{t("mobile.activity.recent")}</SectionLabel>
        <MCard padded={false}>
          {filtered.length === 0 ? (
            <div
              style={{
                padding: "40px 20px",
                textAlign: "center",
                color: T.inkSoft,
                fontSize: 14,
              }}
            >
              {t("mobile.activity.empty")}
            </div>
          ) : (
            filtered.map((e, i) => (
              <ActivityRow
                key={e.id ?? i}
                event={e}
                isLast={i === filtered.length - 1}
                onClick={
                  e.asset_id
                    ? () => onOpenAsset({ id: e.asset_id!, code: e.asset_code || "" })
                    : undefined
                }
              />
            ))
          )}
        </MCard>
      </div>
    </div>
  )
}
